// action-types.js
export const SET_CHAT_CONTEXT = '@chat/SET_CHAT_CONTEXT';
export const ADD_CHAT_CONTEXT = '@chat/ADD_CHAT_CONTEXT';
export const REMOVE_CHAT_CONTEXT = '@chat/REMOVE_CHAT_CONTEXT';
export const CLEAR_CHAT_CONTEXTS = '@chat/CLEAR_CHAT_CONTEXTS';
export const SET_CHAT_OPEN = '@chat/SET_CHAT_OPEN';
export const SET_CHAT_FULLSCREEN = '@chat/SET_CHAT_FULLSCREEN';

// ==============================|| CHAT CONTEXT REDUCER ||============================== //

const initialState = {
  context: null, // Keep for backward compatibility
  contexts: [], // New array for multiple contexts
  selectedElements: [], // Track selected elements for highlighting
  selectedTextRanges: [], // Track selected text ranges for highlighting
  isChatOpen: false, // Track if chat is open for beta feature
  isChatFullscreen: false // Track if chat is fullscreen
};

const chatContextReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CHAT_CONTEXT:
      return {
        ...state,
        context: action.payload
      };
    case ADD_CHAT_CONTEXT: {
      const newContext = {
        id: Date.now(),
        content: action.payload.content,
        timestamp: Date.now(), // Store as number instead of Date object
        type: 'context',
        elementId: action.payload.elementId || null,
        selectionType: action.payload.selectionType || 'card', // 'card' or 'text' or 'report'
        textRange: action.payload.textRange || null,
        label: action.payload.label || null,
        href: action.payload.href || null,
        reportType: action.payload.reportType || null
      };

      let newSelectedElements = state.selectedElements;
      let newSelectedTextRanges = state.selectedTextRanges;

      if (action.payload.selectionType === 'text' && action.payload.textRange) {
        newSelectedTextRanges = [...state.selectedTextRanges, action.payload.textRange];
      } else if (action.payload.elementId) {
        newSelectedElements = [...state.selectedElements, action.payload.elementId].filter(Boolean);
      }

      return {
        ...state,
        contexts: [...state.contexts, newContext],
        selectedElements: newSelectedElements,
        selectedTextRanges: newSelectedTextRanges
      };
    }
    case REMOVE_CHAT_CONTEXT: {
      const contextToRemove = state.contexts.find((ctx) => ctx.id === action.payload);

      let newSelectedElements = state.selectedElements;
      let newSelectedTextRanges = state.selectedTextRanges;

      if (contextToRemove?.selectionType === 'text' && contextToRemove.textRange) {
        newSelectedTextRanges = state.selectedTextRanges.filter((range) => range.id !== contextToRemove.textRange.id);
      } else if (contextToRemove?.elementId) {
        newSelectedElements = state.selectedElements.filter((id) => id !== contextToRemove.elementId);
      }

      return {
        ...state,
        contexts: state.contexts.filter((ctx) => ctx.id !== action.payload),
        selectedElements: newSelectedElements,
        selectedTextRanges: newSelectedTextRanges
      };
    }
    case CLEAR_CHAT_CONTEXTS:
      return {
        ...state,
        contexts: [],
        selectedElements: [],
        selectedTextRanges: []
      };
    case SET_CHAT_OPEN:
      return {
        ...state,
        isChatOpen: action.payload
      };
    case SET_CHAT_FULLSCREEN:
      return {
        ...state,
        isChatFullscreen: action.payload
      };
    default:
      return state;
  }
};

export default chatContextReducer;

export const setChatContext = (context) => ({
  type: SET_CHAT_CONTEXT,
  payload: context
});

export const addChatContext = (
  content,
  elementId = null,
  selectionType = 'card',
  textRange = null,
  label = null,
  href = null,
  reportType = null
) => ({
  type: ADD_CHAT_CONTEXT,
  payload: { content, elementId, selectionType, textRange, label, href, reportType }
});

export const removeChatContext = (contextId) => ({
  type: REMOVE_CHAT_CONTEXT,
  payload: contextId
});

export const clearChatContexts = () => ({
  type: CLEAR_CHAT_CONTEXTS
});

export const setChatOpen = (isOpen) => ({
  type: SET_CHAT_OPEN,
  payload: isOpen
});

export const setChatFullscreen = (isFullscreen) => ({
  type: SET_CHAT_FULLSCREEN,
  payload: isFullscreen
});
